// extracted by mini-css-extract-plugin
export default {"footerButtons":"styles_footerButtons__8ZrJt","content":"styles_content__z9DHN"};